import { render, staticRenderFns } from "./rateAdjustmentRecord.vue?vue&type=template&id=90a65056&"
import script from "./rateAdjustmentRecord.vue?vue&type=script&lang=js&"
export * from "./rateAdjustmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./rateAdjustmentRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports